import Box from '@mui/material/Box';

import { Order } from '~hooks/useOrders/models';

import OrdersListCard from './OrdersListCard';

interface OrdersListProps {
  orders: Order[];
}

export default function OrdersList({ orders }: OrdersListProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, width: '100%' }}>
      {orders.map((order) => (
        <OrdersListCard key={order.orderId} order={order} />
      ))}
    </Box>
  );
}
